import endpointUrls from 'global/Constants/endpointUrls';
import { customerProductStatus } from 'global/Models/branchCustomerProductTypeModel';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { setCustomerBranchProduct } from 'redux/reducer/customerBranchProduct/customerBranchProductReducer';
import { AppDispatch } from 'redux/store';

export const customerBranchProductGetAllStatuses = () => async (dispatch: AppDispatch) => {
  await ApiService.get(endpointUrls.branchCustomerProductGetAllStatus)
    .then((res: IBackendSearchGeneric<customerProductStatus>) =>
      handleApiThenGeneric<IBackendSearchGeneric<customerProductStatus>, customerProductStatus[]>({
        res,
        notifFail: false,
        notifSuccess: false,
        onSuccessData: (data) => {
          dispatch(setCustomerBranchProduct(data));
        },
        onFailed: () => {},
      })
    )
    .catch(() => {});
};
